import config from '../../config';

const { accountBaseUrl = '' } = config() || {};

export const skipLinks = [
  {
    title: 'Skip to main content',
    href: '#main',
  },
  {
    title: 'Skip to footer',
    href: '#footer',
  },
];

export const topLinks = [
  {
    title: 'About us',
    href: '/customer-services/about-us',
  },
  {
    title: 'Our shops',
    href: '/our-shops',
  },
  {
    title: 'Customer services',
    href: '/customer-services',
  },
  {
    title: 'Our services',
    href: '/our-services',
  },
  {
    title: 'Track order',
    href: `${accountBaseUrl}/track-order`,
  },
  {
    title: 'My John Lewis',
    href: '/our-services/my-john-lewis',
  },
  {
    title: 'Partnership Card',
    href: 'https://www.johnlewisfinance.com/partnership-card.html?track=XC50',
    external: true,
  },
  {
    title: 'Insurance',
    href: 'https://www.johnlewisfinance.com/insurance.html?track=JLj0008',
    external: true,
  },
];

export const getAccountLinks = baseUrl => [
  {
    title: 'My account',
    href: '/my-account',
  },
  {
    title: 'My John Lewis rewards',
    href: `${baseUrl || ''}/rewards`,
  },
  {
    title: 'Wish list',
    href: `${baseUrl || ''}/wish-list`,
  },
  {
    title: 'Appointments',
    href: '/appointments/manage',
  },
  {
    title: 'Sign out',
    href: '/sign-out',
  },
];

export const getMobileLinks = baseUrl => [
  {
    title: 'My Account',
    href: '/my-account',
    mobileOnly: true,
    items: [
      {
        title: 'Sign in',
        href: '/sign-in',
        mobileOnly: true,
        accountHeaderOnly: true,
      },
      {
        title: 'Track Order',
        href: `${baseUrl || ''}/track-order`,
        mobileOnly: true,
      },
      {
        title: 'My John Lewis rewards',
        href: `${baseUrl || ''}/rewards`,
        mobileOnly: true,
      },
      {
        title: 'Wish List',
        href: `${baseUrl || ''}/wish-list`,
        mobileOnly: true,
      },
    ],
    authenticatedItems: [
      {
        title: 'View my account',
        href: '/my-account',
        mobileOnly: true,
      },
      {
        title: 'Track my order',
        href: `${baseUrl || ''}/track-order`,
        mobileOnly: true,
      },
      {
        title: 'My John Lewis rewards',
        href: `${baseUrl || ''}/rewards`,
        mobileOnly: true,
      },
      {
        title: 'Wish List',
        href: `${baseUrl || ''}/wish-list`,
        mobileOnly: true,
      },
      {
        title: 'Sign out',
        href: 'https://www.johnlewis.com/sign-out',
        mobileOnly: true,
        accountHeaderOnly: true,
      },
    ],
  },
  {
    title: 'Help',
    href: '/customer-services',
    mobileOnly: true,
    items: [
      {
        title: 'Customer services',
        href: '/customer-services',
        mobileOnly: true,
      },
      {
        title: 'Delivery & collection',
        href: '/customer-services/delivery-information',
        mobileOnly: true,
      },
      {
        title: 'Returns & refunds',
        href: '/customer-services/returns',
        mobileOnly: true,
      },
      {
        title: 'Shop finder',
        href: '/our-shops',
        mobileOnly: true,
      },
    ],
  },
  {
    title: 'Services and experiences',
    href: '/our-services',
    mobileOnly: true,
    items: [
      {
        title: 'Our services',
        href: '/our-services',
        mobileOnly: true,
      },
      {
        title: 'More from us',
        href: '/our-services/more-from-john-lewis',
        mobileOnly: true,
      },
    ],
  },
];
